<template>
    <div>
        <template v-if="isAuth">
            <login></login>
        </template>

        <template v-else>
            <div class="wrapper ">
                <sidebar></sidebar>
                <!--END Sidebar-->

                <div class="main-panel">

                    <div class="content">
                        <div class="container-fluid">
                            <router-view></router-view>
                            <vue-progress-bar></vue-progress-bar>
                        </div>
                    </div>
                    <!--END Content-->

                </div>
                <!--END Main Content-->
            </div>
        </template>
    </div>
</template>

<script>
    import Login from './Auth/Login.vue'
    import Sidebar from './Partials/Sidebar.vue'
    import Navbar from './Partials/Navbar.vue'

    export default {
        name: "Index",
        components: {
            Login,
            Sidebar,
        },
        data() {
            return {
                isAuth: false
            }
        },
        methods: {
            checkIfAuthPage() {
              this.isAuth = this.$route.matched.some(({ name }) => name === 'AuthLogin');
            }
        },
        created() {
            this.checkIfAuthPage()
        }
    }
</script>

<style scoped>

</style>